import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import paperBin from 'assets/images/think/paperbin.svg';
import link from 'assets/images/think/link.svg';
import pdf from 'assets/images/think/pdf.svg';
import photo from 'assets/images/think/photo.svg';
import Avatar from 'components/Avatar';
import ConfirmModal from 'components/ConfirmModal';
import { getUserData } from 'routes/Profile/modules/actions';
import { deleteProposedContent } from 'components/ThinkTanks/modules/actions';
import { ContentSimpleCardWrapper, TypePhoto } from './styles';

function ContentSimpleCard(props) {
  const {
    data, classesList, actualUser, literals, app, recognized, isDragging,
  } = props;

  const style = {};
  if (data.image) {
    style.backgroundImage = `url(${data.image})`;
  }

  const [user, setUser] = useState(null);
  const [killModal, setKillModal] = useState(false);

  const deleteC = () => {
    const { onDelete } = props;
    deleteProposedContent(data.id, actualUser.id).then(() => {
      onDelete();
    });
  };

  const openModal = () => {
    setKillModal(!killModal);
  };

  const printKillModal = () => {
    if (!killModal) {
      return null;
    }
    return (
      <div>
        <ConfirmModal
          onAccept={deleteC}
          onClose={openModal}
          open
          confirmText={literals.confirmDelete}
        />
      </div>
    );
  };

  useEffect(() => {
    if (data.user_id) {
      getUserData(data.user_id)
        .then((userData) => {
          setUser(userData.info);
        });
    }
  }, []);

  const classesStr = classesList.join(' ');
  let content = '';

  const getTypeName = () => {
    let typeName = literals.file;

    if (data.type[0] === 'referral') {
      typeName = literals.link;
    } else {
      switch (data.info_type) {
        case 'application/pdf':
          typeName = literals.pdf;
          break;
        case 'image/jpeg' || 'image/png' || 'image/jpg':
          typeName = literals.image;
          break;
        default:
          break;
      }
    }

    return typeName;
  };

  const download = () => {
    if (!isDragging) {
      if (data.info.includes('http')) {
        window.open(data.info);
      } else {
        window.open(`https://${data.info}`);
      }
    }
  };

  if (data.type[0] === 'referral') {
    content = (
      <TypePhoto onClick={download}>
        <img src={link} alt='' />
      </TypePhoto>
    );
  } else {
    switch (data.info_type) {
      case 'application/pdf':
        content = (
          <TypePhoto onClick={download}>
            <img src={pdf} alt='' />
          </TypePhoto>
        );
        break;
      case 'image/jpeg' || 'image/png' || 'image/jpg':
        content = (
          <TypePhoto onClick={download}>
            <img src={photo} alt='' />
          </TypePhoto>
        );
        break;
      default:
        break;
    }
  }

  return (
    <ContentSimpleCardWrapper className={classesStr}>
      <div className='bodyTop' onClick={download}>
        <div className='type' style={{ color: app.color1 }}>{getTypeName()}</div>
        <div className='title'>{data.name}</div>
      </div>
      <div className='header'>
        {(parseInt(actualUser.id, 10) === parseInt(data.user_id, 10) || recognized) && <img src={paperBin} alt='' className='paperbin' onClick={openModal} />}
        {content}
      </div>
      <div className='body' onClick={download}>
        {user ? (
          <div>
            <Avatar size={25} firstname={user.firstname} id={user.id} avatar={user.avatar} />
            <div className='text_name'>{`${user.firstname} ${user.lastname}`}</div>
          </div>
        ) : <div />}
      </div>
      <div className='footer' />
      {printKillModal()}
    </ContentSimpleCardWrapper>
  );
}

ContentSimpleCard.propTypes = {
  data: PropTypes.object.isRequired,
  classesList: PropTypes.array,
  isDragging: PropTypes.bool,
};

ContentSimpleCard.defaultProps = {
  classesList: [],
  isDragging: false,
};

export default ContentSimpleCard;



// WEBPACK FOOTER //
// ./src/components/Cards/ContentSimpleCard/components/index.jsx